import parse from 'html-react-parser';
import {
    getSession,
    getPrefetch,
    renderHTML,
    getAPPID,
    } from '../../../common/Helpers/index';
import { lazyWithPreload } from '../../../common/Helpers/lazyWithPrefetch';
import { store } from '../../../../configureStore';
import { goToProcessStep } from '../../../../redirection';
import { commonErrors } from '../../../common/Helpers/constants';

export const performPreFetch = () => {
    if (!getPrefetch()) {
      return;
    }
    const flowType = getSession('FlowType');
    const isCBandQual = getSession('isCBandQual');
    const selectedSetupOption = getSession('selectedSetupOption');
    if ((flowType === '5G' && isCBandQual === 'Y' && selectedSetupOption === 'SELF') || flowType === 'LTE') {
      const ComponentToPreload = lazyWithPreload(() => import(/* webpackPrefetch: true */ '../../ShippingInfo/redesign/index'));
      if (typeof ComponentToPreload?.preload === 'function') ComponentToPreload.preload();
    } else if (flowType === '5G' && isCBandQual !== 'Y' && selectedSetupOption === 'PROFESSIONAL') {
      const ComponentToPreload = lazyWithPreload(() => import(/* webpackPrefetch: true */ '../../CreditCheck/redesign/index'));
      if (typeof ComponentToPreload?.preload === 'function') ComponentToPreload.preload();
    }
  };

export const notificationProps =(propsVal)=> {
  const notificationVal = {
    renderIf: false,
    title: '',
    type: 'warning',
    serviceInfo: '',
    subtitle: '',
  };
  const billingAddressError = propsVal.billingAddressError || false;
    const isInvalidZipcodeError = propsVal.isInvalidZipcodeError || false;
    const isLoggedIn = getAPPID() === 'AAL';
      if (propsVal.isBTAEligible && propsVal.paymentInfoState && propsVal.paymentInfoState.confirmSubmitCall) {
        if (propsVal.paymentInfoState && propsVal.paymentInfoState.paymentSuccess && propsVal.paymentInfoState.paymentSuccess.status === 200) {
          const updateView = propsVal.currentView.PRO.OrderReview;
          // debugger;
          goToProcessStep(updateView, propsVal.history);
          store.dispatch({ type: 'REDIRECT_DONE', value: true });
          store.dispatch({ type: 'CONFIRM_SUBMIT_CALL', value: false });
          store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: false });
        } else if (propsVal.paymentInfoState && propsVal.paymentInfoState.errorDetails && propsVal.paymentInfoState.errorDetails.showError) {
          store.dispatch({ type: 'CONFIRM_SUBMIT_CALL', value: false });
          store.dispatch({ type: 'IS_BTA_ELIGIBLE', value: false });
          notificationVal.title = propsVal?.paymentInfoState?.errorDetails?.notifyErrorMessage
            ? propsVal?.paymentInfoState?.errorDetails?.notifyErrorMessage
            : 'We are unable to process the request at this time. Please try after sometime';
          notificationVal.renderIf =
            propsVal.paymentInfoState && propsVal.paymentInfoState.errorDetails && propsVal.paymentInfoState.errorDetails.showError;
          notificationVal.serviceInfo = propsVal.serviceinfo;
        }
      }
        if (propsVal.contactInfoError && !propsVal.contactInvalidCaseError) {
            notificationVal.title = renderHTML(propsVal.contactInfoNtfyMsg || commonErrors?.defaultMessage);
            notificationVal.renderIf = true;
            notificationVal.serviceInfo = propsVal.serviceinfo;
          } else if (propsVal?.contactInvalidCaseError) {
            notificationVal.title = parse(commonErrors?.transactionExpired || '');
            notificationVal.renderIf = propsVal?.contactInvalidCaseError;
            notificationVal.serviceInfo = propsVal.serviceinfo;
          } else if (billingAddressError) {
            notificationVal.title = propsVal.adressError || 'Address not found, please re-enter';
            notificationVal.renderIf = billingAddressError;
            notificationVal.serviceInfo = propsVal.serviceinfo;
          } else if (isInvalidZipcodeError) {
            notificationVal.title = 'Please enter a valid zipcode';
            notificationVal.renderIf = isInvalidZipcodeError;
            notificationVal.serviceInfo = propsVal.serviceinfo;
          } else if (isLoggedIn && propsVal.contactInfoEditError && propsVal.contactInfoEditError !== '') {
            notificationVal.title = propsVal.contactInfoEditError;
            notificationVal.renderIf = isLoggedIn && propsVal.contactInfoEditError && propsVal.contactInfoEditError !== '';
            notificationVal.serviceInfo = propsVal.serviceinfo;
          } else if (propsVal.updatePersonalError) {
            notificationVal.title = propsVal.notifyMessage || 'Looks like something went wrong. Please try again later.';
            notificationVal.renderIf = propsVal.updatePersonalError;
            notificationVal.serviceInfo = propsVal.serviceinfo;
          }
        return notificationVal;
}  